export default __webpack_public_path__ + "static/media/4.428c0fb0.png";